const CoinPurchaseDisclaimer = ({ disclaimer }) => (
  <p className="tc f--1 t-pv3 t-ph2 white t-ph3-ns lh-copy fw4 t-mt4 t-mb3 ttu bg-yellow-2 mw6 t-center">
    {disclaimer}
  </p>
);

CoinPurchaseDisclaimer.defaultProps = {
  disclaimer:
    "UNLOCKING PREMIUM CONTENT REQUIRES POP COINS, WHICH CAN ONLY BE PURCHASED ON THE MOBILE APP"
};

export default CoinPurchaseDisclaimer;
